import React from 'react';
import { motion } from 'framer-motion';
import { SectionMarker } from './SectionMarker';
export function MechanismSection() {
  const stressFactors = ['Estrés no procesado', 'Sobrecarga mental', 'Exposición constante a pantallas', 'Autoexigencia', 'Preocupaciones anticipadas'];
  return <section className="w-full bg-navy-darkest py-10 md:py-14" data-id="element-113">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-115">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-116">
            <SectionMarker data-id="element-117" />
            <span className="text-cream-muted text-sm uppercase tracking-wider" data-id="element-118">
              El mecanismo
            </span>
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-12" data-id="element-119">
            Lo que ocurre cuando despiertas a esa hora
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-10" data-id="element-120">
          <p className="text-lg text-cream-muted mb-6" data-id="element-121">
            Durante el día acumulas:
          </p>

          <ul className="space-y-3" data-id="element-122">
            {stressFactors.map((factor, index) => <motion.li key={factor} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.1 * index
          }} className="flex items-center gap-3 text-cream" data-id="element-123">
                <span className="text-amber" data-id="element-124">–</span>
                <span data-id="element-125">{factor}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="space-y-6 text-lg text-cream-muted leading-relaxed" data-id="element-126">
          <p data-id="element-127">
            Tu cuerpo lo interpreta como{' '}
            <span className="text-cream" data-id="element-128">amenaza</span>.
          </p>

          <p data-id="element-129">Y un cuerpo que percibe amenaza no duerme profundamente.</p>

          <p className="text-cream" data-id="element-130">
            Aumenta cortisol. Mantiene vigilancia. Activa el modo alerta.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-12 p-6 border-l-4 border-amber bg-navy-dark/50 rounded-r-lg" data-id="element-131">
          <p className="font-playfair text-xl md:text-2xl italic text-amber leading-relaxed" data-id="element-132">
            Dormir en ese estado es como pedirle a un guardia que se duerma en
            medio de un incendio.
          </p>
          <p className="mt-4 text-2xl font-bold text-cream" data-id="element-133">No puede.</p>
        </motion.div>
      </div>
    </section>;
}